import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import useChatSocket from '../../hooks/useChatSocket';

export default function ChatWindow({ conversationId, sender, title, onClose }) {
  const { t } = useTranslation();
  const [draft, setDraft] = useState('');
  const endRef = useRef(null);

  const { messages, connected, loading, send } = useChatSocket({
    conversationId,
    senderId: sender.id,
    senderName: sender.name,
    senderType: sender.type,
  });

  useEffect(() => {
    endRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [messages]);

  const submit = (e) => {
    e.preventDefault();
    if (!draft.trim()) return;
    send(draft);
    setDraft('');
  };

  const fmt = (iso) =>
    iso ? new Date(iso).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }) : '';

  return (
    <div className="chat-window">
      <div className="chat-head">
        <span>
          <span className={`chat-dot ${connected ? 'on' : 'off'}`} />{' '}
          {title || t('chat.support')}
        </span>
        <button onClick={onClose} aria-label={t('common.close')}><i className="bi bi-x-lg" /></button>
      </div>

      <div className="chat-body">
        {loading ? (
          <p className="chat-empty">{t('chat.loadingMessages')}</p>
        ) : messages.length === 0 ? (
          <p className="chat-empty">{t('chat.welcome')}</p>
        ) : (
          messages.map((m, i) => {
            const mine = m.senderId === sender.id;
            return (
              <div key={m.id || i} className={`chat-msg ${mine ? 'mine' : ''}`}>
                <div className="bubble">{m.content}</div>
                <small>{m.senderType === 'ADMIN' && !mine ? `${t('chat.support')} · ` : ''}{fmt(m.createdAt)}</small>
              </div>
            );
          })
        )}
        <div ref={endRef} />
      </div>

      <form className="chat-input" onSubmit={submit}>
        <input
          value={draft}
          onChange={(e) => setDraft(e.target.value)}
          placeholder={t('chat.typeMessage')}
        />
        <button type="submit" disabled={!draft.trim()} aria-label={t('common.submit')}>
          <i className="bi bi-send-fill" />
        </button>
      </form>
    </div>
  );
}
